export const PUBLIC_APP_PATH_PREFIXES = [
  '/login',
  '/register',
  '/forgot-password',
  '/reset-password',
  '/report/',
  '/w/',
];

export function isPublicAppPath(pathname) {
  const path = pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
  return PUBLIC_APP_PATH_PREFIXES.some((prefix) => path.startsWith(prefix));
}
